//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { FeedValidationError } from '@apis/catalog-validation/catalogValidationModel';
import { ERROR_COLUMNS } from '@catalog-ingestion/constants/reviewPanelConstants';

export const getErrorColumnIndices = (error: FeedValidationError): number[] => {
  const errorColumnIndices: number[] = [];
  switch (error) {
    case FeedValidationError.DUPLICATE_ID:
    case FeedValidationError.MALFORMED_ID:
    case FeedValidationError.MISSING_ID:
      errorColumnIndices.push(ERROR_COLUMNS.ID);
      break;
    case FeedValidationError.MALFORMED_TITLE:
    case FeedValidationError.MISSING_TITLE:
      errorColumnIndices.push(ERROR_COLUMNS.TITLE);
      break;
    case FeedValidationError.MALFORMED_LINK:
    case FeedValidationError.MISSING_LINK:
    case FeedValidationError.UNREACHABLE_LINK:
      errorColumnIndices.push(ERROR_COLUMNS.LINK);
      break;
    case FeedValidationError.MALFORMED_IMAGE_LINK:
    case FeedValidationError.MISSING_IMAGE_LINK:
    case FeedValidationError.UNREACHABLE_IMAGE_LINK:
      errorColumnIndices.push(ERROR_COLUMNS.IMAGE_LINK);
      break;
  }
  return errorColumnIndices;
};
